document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.mobile-toggle');
  const nav = document.querySelector('#site-nav');
  if (btn && nav) {
    btn.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }
  document.querySelectorAll('.shop-dropdown').forEach(dropdown => {
    const toggle = dropdown.querySelector('.shop-dropdown-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const open = dropdown.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    dropdown.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        dropdown.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });
});
